export const SELECT_MODELE = "SELECT_MODELE";
export const SELECT_POSITION = "SELECT_POSITION";
export const SELECT_COLOR = "SELECT_COLOR";
export const COLOR_SQUARE = "COLOR_SQUARE";
export const STORE_IMAGE_DATA = "STORE_IMAGE_DATA";
export const STORE_CANVAS = "STORE_CANVAS";
export const COMPARE_WITH_MODEL = "COMPARE_WITH_MODEL";
export const RESET_COMPARISON = "RESET_COMPARISON";
export const CLEAR_SQUARES = "CLEAR_SQUARES";

export const selectModele = id => {
    return {
        type: SELECT_MODELE,
        payload: id,
    };
};
export const selectPosition = pos => {
    return {
        type: SELECT_POSITION,
        payload: pos,
    };
};
export const selectColor = color => {
    return {
        type: SELECT_COLOR,
        payload: color,
    };
};
export const colorSquare = ({ row, col }, color) => {
    return {
        type: COLOR_SQUARE,
        payload: [row, col, color],
    };
};
export const storeImageData = imageData => {
    return {
        type: STORE_IMAGE_DATA,
        payload: imageData,
    };
};
export const storeCanvas = canvas => {
    return {
        type: STORE_CANVAS,
        payload: canvas,
    };
};
export const compare = ({ modele, reprod }) => {
    return {
        type: COMPARE_WITH_MODEL,
        payload: { modele, reprod },
    };
};
export const resetComparison = _ => {
    return {
        type: RESET_COMPARISON,
    };
};
export const clearSquares = _ => {
    return {
        type: CLEAR_SQUARES,
    };
};
